import { type PlanType, MembershipInterval } from '@/features/account/services/MembershipPlan/types'

export const getMembershipType = (interval: string, intervalCount = 1): PlanType => {
  switch (interval) {
    case MembershipInterval.year:
      if (intervalCount > 1) {
        return `${intervalCount} Year`
      } else {
        return 'Annual'
      }
    case MembershipInterval.month:
      if (intervalCount > 1) {
        return `${intervalCount} Month`
      } else {
        return 'Monthly'
      }
    default:
      return 'Membership'
  }
}
